import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { getLocalizedAddress, getLocationDisplayWithAddressText } from 'owa-location-persona';
import TxpLocation from '../../components/TxpLocation';
import getTxpLocationIcon from './getTxpLocationIcon';
import OwaTxpStyle from '../../store/viewSchema/OwaTxpStyle';
import TxpImages from 'txp-data/lib/schema/configSchema/TxpImages';

export default function getTxpLocation(
    txpLocation: EnhancedLocation,
    showFullAddress: boolean,
    txpImages?: TxpImages,
    txpStyle?: OwaTxpStyle,
    telephone?: string
): JSX.Element {
    let txpLocationComponent: JSX.Element = null;

    if (
        txpLocation &&
        (!isNullOrWhiteSpace(txpLocation.DisplayName) ||
            getLocalizedAddress(txpLocation.PostalAddress))
    ) {
        let locationToDisplay: string = showFullAddress
            ? getLocationDisplayWithAddressText(txpLocation.DisplayName, txpLocation.PostalAddress)
            : getLocalizedAddress(txpLocation.PostalAddress);

        txpLocationComponent = TxpLocation({
            txpLocation: txpLocation,
            txpLocationIcon: getTxpLocationIcon(txpImages),
            locationToDisplay: locationToDisplay,
            txpStyle,
            telephone,
        });
    }

    return txpLocationComponent;
}
